// mirrors backend MAX_BULK_FAULT_EVENTS in app/schemas/fault_event/fault_event_comment.py
export const MAX_BULK_FAULT_EVENTS = 1000;

export const FAULT_EVENT_PAGE_SIZES = [10, 100, 500, 1000];
